import VendorPaymentContainer from "./VendorPaymentContainer";
export default VendorPaymentContainer;
